import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getTailoredAudits = api(function getTailoredAudits({ referenceId, scheduleVersion, scheduleId }) {
    return query(
        gql`
            query GetTailoredAudits($referenceId: String!, $scheduleVersion: String!, $scheduleId: String) {
                getTailoredAudits(
                    referenceId: $referenceId
                    scheduleVersion: $scheduleVersion
                    scheduleId: $scheduleId
                ) {
                    id
                    shortDescription
                    longDescription
                    referenceId
                    type
                    date
                    userId
                    userName
                    payload
                }
            }
        `,
        { referenceId, scheduleVersion, scheduleId },
        { returns: "getTailoredAudits" }
    )
})
